// extracted by mini-css-extract-plugin
export default {"fluid":"fluid-RYHYv","name":"name-OVJq3","settingsTitle":"settingsTitle-OO0Sd"};